import React, { useState, useEffect } from "react";
import "../styles/Modal.css";

interface TtsSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  ttsEnabled: boolean;
  onSave: (enabled: boolean) => void;
}

const TtsSettingsModal: React.FC<TtsSettingsModalProps> = ({
  isOpen,
  onClose,
  ttsEnabled,
  onSave,
}) => {
  const [enabled, setEnabled] = useState(ttsEnabled);

  useEffect(() => {
    setEnabled(ttsEnabled);
  }, [ttsEnabled]);

  const handleSave = () => {
    onSave(enabled);
    onClose();
  };

  const handleCancel = () => {
    setEnabled(ttsEnabled); // 원래 값으로 되돌리기
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleCancel}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>TTS (음성 합성) 설정</h3>
          <button className="modal-close-btn" onClick={handleCancel}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="tts-settings-content">
            <div className="setting-item">
              <label className="checkbox-container">
                <input
                  type="checkbox"
                  checked={enabled}
                  onChange={(e) => setEnabled(e.target.checked)}
                />
                <span className="checkmark"></span>
                <span className="checkbox-label">TTS 활성화</span>
              </label>
              <p className="setting-description">
                번역된 텍스트를 음성으로 들을 수 있습니다.
              </p>
            </div>

            <div className="tts-info">
              <div className="info-box">
                <h4>📢 TTS 안내사항</h4>
                <ul>
                  <li>
                    TTS는 현재 <strong>영어</strong>만 지원됩니다.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={handleCancel}>
            취소
          </button>
          <button className="btn-primary" onClick={handleSave}>
            저장
          </button>
        </div>
      </div>
    </div>
  );
};

export default TtsSettingsModal;
